(function(){
"use strict";

function payloadFor(canvas){
  var direct=canvas.getAttribute("data-qr-url");
  if(direct)return direct;
  var aria=canvas.getAttribute("aria-label")||"";
  var m=aria.match(/QR-kod till\s+(https?:\/\/\S+)/i);
  return m?m[1]:"";
}
function sizeFor(canvas){
  if(canvas.id==="sell-qr")return 164;
  if(canvas.id==="big-qr")return 287;
  if(canvas.id==="modal-qr")return 246;
  if(canvas.id==="poster-qr")return 164;
  if(canvas.id==="kp-poster-qr")return 123;
  return 205;
}
function fixOne(canvas){
  if(!canvas||!window.KampanseraReliableQR)return;
  var text=payloadFor(canvas);
  if(!text)return;
  if(canvas.dataset.kpReliablePayload===text&&canvas.dataset.qrVerified==="true")return;
  window.KampanseraReliableQR.toCanvas(canvas,text,{
    width:sizeFor(canvas),
    margin:4,
    errorCorrectionLevel:"M",
    color:{dark:"#14162B",light:"#FFFFFF"}
  }).then(function(){
    canvas.dataset.kpReliablePayload=text;
  }).catch(function(){});
}
function scan(){
  document.querySelectorAll("canvas[data-qr-url],canvas#sell-qr,canvas#big-qr,canvas#modal-qr,canvas#poster-qr").forEach(fixOne);
}
var scheduled=false;
function schedule(){
  if(scheduled)return;
  scheduled=true;
  requestAnimationFrame(function(){scheduled=false;scan();});
}
window.addEventListener("hashchange",function(){setTimeout(scan,120);});
var app=document.getElementById("app");
if(app&&window.MutationObserver)new MutationObserver(schedule).observe(app,{childList:true,subtree:true});
setTimeout(scan,500);
})();